import React from 'react';
import { bool, number, string, shape, arrayOf } from 'prop-types';
import { DESKTOP_BREAKPOINT } from 'utils/constants/breakpoints';
import chunks from 'utils/chunks';
import River from 'components/shared/River';
import * as styles from './styles/styles.module.scss';
import ActivitySuitabilityImage from './ActivitySuitabilityImage';

const ARROW_STYLES = { next: styles.next, previous: styles.prev };

const ActivitySuitabilityRiver = ({ activities, mobileBrowser, windowWidth }) => {
  const mobileColumns = mobileBrowser || (windowWidth && windowWidth <= DESKTOP_BREAKPOINT);

  const chunkedActivities = [...chunks(activities, mobileColumns ? 3 : 2)];

  const slickSettings = { slidesToShow: 3, lazyLoad: 'progressive', slidesToScroll: 3, speed: 750 };

  return (
    <River useSlick={windowWidth >= 1270} slickSettings={slickSettings} arrowStyles={ARROW_STYLES}>
      {chunkedActivities.map(group => {
        return (
          <div className={mobileColumns ? styles.mobileColumns : styles.columns} key={group[0].title}>
            {group.map(activity => {
              return (
                <ActivitySuitabilityImage
                  url={activity.explore_url}
                  src={activity.photo_urls.square.two}
                  title={activity.title}
                  key={activity.title}
                />
              );
            })}
          </div>
        );
      })}
    </River>
  );
};

ActivitySuitabilityRiver.propTypes = {
  mobileBrowser: bool,
  windowWidth: number,
  activities: arrayOf(
    shape({
      title: string,
      explore_url: string,
      photo_urls: shape({
        square: shape({
          two: string,
          three: string
        })
      })
    })
  ).isRequired
};

ActivitySuitabilityRiver.defaultProps = {
  mobileBrowser: true,
  windowWidth: null
};

export default ActivitySuitabilityRiver;
